import { Controller } from "@hotwired/stimulus";
import Axios from "axios";

// The note Attachments panel's list/icons toggle (LI-247; see
// notes/attachments_panel/component.html.haml). Both views are always rendered, so switching
// only swaps the `notes-attachments--icons` modifier, then saves the choice in the background
// (fire and forget; guests have no url value and nothing is saved).
//
// An image tile's thumbnail URL waits in data-src until icons view is actually shown, so
// thumbnails are only generated for people who look at them. Tiles that arrive later by Turbo
// Stream (upload, rename) get theirs straight away if icons view is already on.
export default class extends Controller {
  static targets = ["button", "thumbnail"];
  static values = { view: String, url: String };

  select({ params: { view } }) {
    if (view === this.viewValue) return;

    this.viewValue = view;
    this.save(view);
  }

  viewValueChanged(view) {
    const icons = view === "icons";

    this.element.classList.toggle("notes-attachments--icons", icons);
    this.buttonTargets.forEach((button) => {
      const pressed = button.dataset.attachmentsViewViewParam === view;
      button.setAttribute("aria-pressed", String(pressed));
      button.classList.toggle("is-active", pressed);
    });
    if (icons) this.thumbnailTargets.forEach((img) => this.load(img));
  }

  thumbnailTargetConnected(img) {
    if (this.viewValue === "icons") this.load(img);
  }

  // A thumbnail that can't be built answers 404: drop the <img> so the extension icon under it
  // shows instead.
  fallback(event) {
    event.target.remove();
  }

  load(img) {
    if (!img.getAttribute("src") && img.dataset.src) img.src = img.dataset.src;
  }

  save(view) {
    if (!this.hasUrlValue) return;

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
    Axios.patch(this.urlValue, { attachments_view: view }, { headers: { "X-CSRF-Token": csrf } }).catch(() => {});
  }
}
